import React, { useState } from "react";
import { Link } from "react-router-dom";
import { quickQueryCards } from "../../types/chat-bot-hub/QuickQueryCards";

interface QuickQueryProps {
  onQuerySelect: (queryText: string) => void;
  quickQueryCards: quickQueryCards[];
}
const QuickQuery: React.FC<QuickQueryProps> = ({ onQuerySelect,quickQueryCards }) => {

  const handleCardClick = (e: React.MouseEvent<HTMLAnchorElement>, text: string) => {
    e.preventDefault();
    onQuerySelect(text);
  };
  return (
    <div className="Cuscards">
      {quickQueryCards.map((card) => (
        <a 
          href="#" 
          key={card.id} 
          className="c_card"
          onClick={(e) => handleCardClick(e, card.query)}
        >
          {card.query}
        </a>
      ))}
    </div>
  );
};

export default QuickQuery;
